import util from './store-utils'

import settings from '../settings'
import { PRODUCT_STORE_COMMIT } from './product-store'

const COMMIT_UPDATE_ORDER_ROW_MESSAGE = "updateOrderRowMessage"
const COMMIT_UPDATE_USER_MODEL = "updateUserModel"
const COMMIT_UPDATE_COMPANY = "updateCompany"
const COMMIT_UPDATE_USER = "updateUser"

export const USER_STORE_COMMIT = {
	DELETE_USER_MODEL: "userStore/deleteUserModel",
	SET_CURRENT_ORDER_ID: "userStore/setCurrentOrderId",
	SET_FILTER: "userStore/setFilter",
	UPDATE_ORDER_ROW_MESSAGE: "userStore/updateOrderRowMessage",
	UPDATE_USER_MODEL: "userStore/updateUserModel",
	SET_TEMP_PRODUCT: "userStore/setTempProduct",
	SET_DISPLAY_PRICE1: "userStore/setDisplayPrice1"
}

export const USER_STORE_ACTION = {
	GET_USER_MODEL: "userStore/getUserModel",
	ADD_PRODUCT_TO_ORDER: "userStore/addProduct",
	IMPORT_PRODUCT_TO_ORDER: "userStore/importProduct",
	GET_ORDER: "userStore/getOrder",
	//GET_ORDER_ROWS: "userStore/getOrderRows",
	DELETE_ORDER_ROW: "userStore/deleteOrderRow",
	CREATE_ORDER: "userStore/createOrder",
	CREATE_ORDER_DROPSHIP: "userStore/createOrder",
	UPDATE_ORDER_ROW: "userStore/updateOrderRow",
	UPDATE_ORDER: "userStore/updateOrder",
	DELETE_ORDER: "userStore/deleteOrder",
	CLOSE_ALL_ORDERS: "userStore/closeAllOrders",
	EXPAND_ALL_ORDERS: "userStore/expandAllOrders",
	FIND_CUSTOMER: "userStore/findCustomer",
	UPDATE_CUSTOMER: "userStore/updateCustomer",
	REMOVE_CUSTOMER: "userStore/removeCustomer",
	UPDATE_COMPANY: "userStore/updateCompany",
	UPDATE_USER: "userStore/updateUser",
	UPDATE_USER_PASSWORD: "userStore/updateUserPassword"


}

export const USER_STORE_GETTER = {
	REQUEST_COUNT: "userStore/requestCount",
	USER_MODEL: "userStore/userModel",
	CURRENT_ORDER: "userStore/currentOrder",
	CURRENT_ORDER_ID: "userStore/currentOrderId",
	GET_ORDER_LIST: "userStore/orderList",
	GET_ORDER_LIST_INDEXED: "userStore/orderListIndexed",
	ORDER_ROW_MESSAGE: "userStore/orderRowMessage",
	GET_CUSTOMER_LIST: "userStore/customerList",
	GET_CUSTOMER_LIST_INDEXED: "userStore/customerListIndexed",
	GET_TEMP_PRODUCT: "userStore/tempProduct",
	DISPLAY_PRICE1: "userStore/displayPrice1"
}

export default {
	namespaced: true,
	state: {
		data: {
			userModel: { orderList: [], customerList: [] }, 
			tempProduct: null, 
			requestCount: 0, 
			currentOrderId: null, 
			filter: "", 
			orderRowMessage: {message: "", active: false, timer: null, timeout: true },
			displayPrice1: false

		},
	},
	getters: {
		userModel(state) {
			return state.data.userModel;
		},
		currentOrderId(state) {
			return state.data.currentOrderId;
		},
		orderList(state) { // FP: Ej indexerad lista utan här är det bara en plain-lista
			var list = state.data.userModel?.orderList?.filter(order => order != null);


			if (state.data.filter != "") {

				list = list.filter(order => {

					var filter = state.data.filter.toLowerCase();

					filter = filter.trim()

					var search = order.orderId + " " + order.orderStatusDate + " " + order.localId + " " + order.contactPerson + " " + order.notes + " " + order.text;

					order.orderRowList.forEach(orderRow => {

						search = search + orderRow.artnr + " " + orderRow.product + " "
					})

					search = search.toLowerCase();

					if (search.includes(filter)) {
						return true
					}

				})

			}


			list = list?.sort((a, b) => {

				if (a.meta.sort == 0 && b.meta.sort == 0) { // FP: SORT fixade sorteringen här 
					return b.orderId - a.orderId
				}

				return a.meta.sort - b.meta.sort

			});

			/*list = list.sort((a, b) => {
				if (a.orderStatus && b.orderStatus && a.orderStatus.status != b.orderStatus.status) {

					return a.orderStatus.status > b.orderStatus.status
				}

				if (a.orderStatusDate && b.orderStatusDate) {
					return a.orderStatusDate < b.orderStatusDate
				}


				return a.orderId < b.orderId

			}

			);*/

			return list;
		},
		orderListIndexed(state) {
			return state.data.userModel?.orderList;

		},
		currentOrder(state) {

			if (state.data.currentOrderId && state.data.userModel && state.data.userModel.orderList && Array.isArray(state.data.userModel.orderList)) {

				//const currentOrder = state.data.userModel.orderList.find(order => order.orderId == state.data.currentOrderId)

				const currentOrder = state.data.userModel.orderList[state.data.currentOrderId];

				if (currentOrder) {

					var quantitySummary = 0;

					currentOrder.orderRowList.forEach(orderRow => { // loopa och räkna utan antal produkter

						quantitySummary += orderRow.quantity

					});

					currentOrder.quantitySummary = quantitySummary

					return currentOrder;
				}


			}

			return null;

		},
		orderRowMessage(state){
			return state.data.orderRowMessage;
		},
		customerList(state){
			var list = state.data.userModel?.customerList?.filter(customer => customer != null);
			return list;
		},
		customerListIndexed(state) {
			return state.data.userModel?.customerList;

		},
		tempProduct(state){
			return state.data.tempProduct;
		},
		displayPrice1(state){
			return state.data.displayPrice1
		}
	},
	actions: {


		userMessageAction({ commit }, { data }) {
			commit('updateUserMessage', data.UserMessage)
		},

		getUserModel({ commit, rootState }, { data }) {

			
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			//const request = util.getPOSTRequest(this.state.loginToken, data.background, { name: "fredde" });

			const request = util.getGETRequest(this.state.loginToken, data.background);

			commit("requestStart");

			return fetch(settings.baseUrl + "model/user", request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {
					console.clear();

					console.log('FP: store action getUserModel json:', json);
					
					if (json.status == "OK") {
						commit(COMMIT_UPDATE_USER_MODEL, json.userModel)
						
						if (json.userModel?.productGroupList) {
							commit(PRODUCT_STORE_COMMIT.UPDATE_PRODUCT_GROUP_LIST, json.userModel.productGroupList, {root: true});
						}
					}

					return json;

				})


			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},

		addProduct({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			const request = util.getPOSTRequest(this.state.loginToken, data.background, data.post);

			if (!data.currentOrderId > 0) {
				if (window.confirm("Du har inte valt en order, en ny order kommer att skapas.")) {
					data.currentOrderId = 0
				} else {
					return;
				}

			}

			if (!data.post.productId > 0) {
				alert("ProductId saknas")
				return;
			}else{
				data.post.productId = parseInt(data.post.productId);
			}

			if (!data.post.quantity > 0) {
				alert("Antal saknas")
				return;
			}

			commit("requestStart");

			const url = "user/order/" + data.currentOrderId + "/order-row"

			return fetch(settings.baseUrl + url, request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {



						if (json.createdOrderId && json.createdOrderId > 0) {
							commit("updateOrder", json.order)
							commit("setCurrentOrderId", json.createdOrderId)
						} else {
							commit("mergeOrder", json.order)
						}

						commit(COMMIT_UPDATE_ORDER_ROW_MESSAGE, { order: json.order, orderRowId: json.orderRowId, orderRowMessage: json.orderRowMessage })
						console.log('FP: order addProduct json: ', json);
						console.log('FP: order addProduct json.order: ', json.order);
						

					}
					return json;

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},

		importProduct({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			const request = util.getPOSTRequest(this.state.loginToken, data.background, data.post);

			if (!parseInt(data.orderId) > 0){
				return;
			}



			commit("requestStart");

			const url = "user/order/" + data.orderId + "/import"

			return fetch(settings.baseUrl + url, request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {

						commit("updateOrderRows", json.order) 

					}

					return json;

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},

		deleteOrderRow({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			const request = util.getDELETERequest(this.state.loginToken, data.background);

			if (!data.currentOrderId > 0) {
				alert("OrderId saknas")
				return;
			}

			if (!data.orderRowId > 0) {
				alert("OrderRowId saknas")
				return;
			}


			// addera indata-parametrar-validering  här 
			commit("requestStart");

			const url = "user/order/" + data.currentOrderId + "/order-row/" + data.orderRowId

			return fetch(settings.baseUrl + url, request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {

						commit("mergeOrder", json.order)
					}

					return json;

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},
		updateOrderRow({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			const request = util.getPOSTRequest(this.state.loginToken, data.background, data.post);

			if (!data.currentOrderId > 0) {
				alert("OrderId saknas")
				return;
			}

			if (!data.post.orderRowId > 0) {
				alert("OrderRowId saknas")
				return;
			}

			if (!data.post.quantity > 0) {
				alert("Antal saknas")
				return;
			}

			commit("requestStart");

			const url = "user/order/" + data.currentOrderId + "/order-row/" + data.post.orderRowId



			return fetch(settings.baseUrl + url, request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {

						commit("mergeOrder", json.order)
						if (!data.popup === false){
							commit(COMMIT_UPDATE_ORDER_ROW_MESSAGE, { order: json.order, orderRowId: json.orderRowId, orderRowMessage: json.orderRowMessage })
						}
						

					}

					return json;

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},
		createOrder({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			const request = util.getPOSTRequest(this.state.loginToken, data.background, data.order);

			commit("requestStart");

			var url = "user/order"

			if (data.dropship){
				url = "user/order-dropship"
			}

			return fetch(settings.baseUrl + url, request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {

						if (json.order && data.dropship) {
							json.order.dropship = true
							commit("resetPreviousOrderId");
						}

						if (json.customer){ // om det skapades en ny kund via dropship
							commit("updateCustomer", json.customer)
						}

						commit("updateOrder", json.order)
						commit("moveOrderFirst", json.order.orderId);

					}

					return json;

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},
		/*
		createOrderDropship({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			const request = util.getPOSTRequest(this.state.loginToken, data.background, data.order);

			commit("requestStart");

			var url = "user/order-dropship"

			return fetch(settings.baseUrl + url, request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data.order, rootState.debug).then(json => {

					if (json.status == "OK") {

						if (json.order){
							json.order.dropship = true
						}
						
						commit("updateOrder", json.order)
						commit("moveOrderFirst", json.order.orderId);


					}

					return json;

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},*/
		updateOrder({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			const request = util.getPOSTRequest(this.state.loginToken, data.background, data.order); // skickar hela order-objektet till backend

			if (!data.order) {
				alert("Order saknas");
				return;
			}

			if (!data.order.orderId > 0) {
				alert("OrderId saknas");
				return;
			}

			commit("requestStart");

			var url = "user/order/" + data.order.orderId + ""

			if (data.send) {
				url = url + "/send"
			}

			return fetch(settings.baseUrl + url, request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {

						commit("updateOrder", json.order)

						if (data.send) {
							alert("skickade in order")

							if (json.order.orderId == rootState.userStore.data.currentOrderId) {
								commit("setCurrentOrderId", null);
							}
						}
					}

					return json;

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},
		deleteOrder({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);



			if (!data.orderId > 0) {
				alert("OrderId saknas")
				return;
			}
			var url = "user/order/" + data.orderId + ""

			const request = util.getDELETERequest(this.state.loginToken, data.background);

			return fetch(settings.baseUrl + url, request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {
						commit("deleteOrder", data.orderId);
						alert("Ordern raderad");

					}



					return json;

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})


		},
		getOrder({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			if (!data.orderId > 0) {
				alert("OrderId saknas");
				return;
			}


			const request = util.getGETRequest(this.state.loginToken, data.background);

			commit("requestStart");

			var url = "user/order/" + data.orderId;

			return fetch(settings.baseUrl + url, request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {

						commit("updateOrder", json.order)

					}

					return json;

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},
		/*getOrderRows({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			if (!data.orderId > 0) {
				alert("OrderId saknas");
				return;
			}


			const request = util.getGETRequest(this.state.loginToken, data.background);

			commit("requestStart");

			var url = "user/order/" + data.orderId;

			return fetch(settings.baseUrl + url, request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {

						commit("updateOrderRows", json.order)

					}

					return json;

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},*/
		findCustomer({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			commit("requestStart");

			const post = {search: data.search}

			

			const request = util.getPOSTRequest(this.state.loginToken, data.background, post);

			const url = "user/order/" + data.orderId + "/customer/search"

			return fetch(settings.baseUrl + url, request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {

						commit("updateOrder", json.order)
						commit("updateCustomer", json.customer)

						console.log('FP: order addProduct json: ', json);
						console.log('FP: order addProduct json.order: ', json.order);
					}

					return json;

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},
		updateCustomer({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			commit("requestStart");

			const customerId = parseInt(data.customer?.customerId);
			const orderId = parseInt(data.orderId);

			if (customerId == 0){
				util.appendEventLogError(commit, "Kund-id saknas", true)
				return;
			}

			if (orderId == 0) {
				util.appendEventLogError(commit, "Order-id saknas", true)
				return;
			}

			const request = util.getPOSTRequest(this.state.loginToken, data.background, data.customer);

			const url = "user/order/" + orderId + "/customer/" + customerId

			return fetch(settings.baseUrl + url, request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {
						commit("updateCustomer", json.customer)
					}

					return json;

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},
		removeCustomer({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			commit("requestStart");

			// data som ska postas

			const orderId = parseInt(data.orderId);

			if (orderId == 0){
				alert("OrderId saknas");
				return;
			}

			const request = util.getDELETERequest(this.state.loginToken, data.background);

			const url = "user/order/" + orderId + "/customer/remove"

			return fetch(settings.baseUrl + url, request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {

						commit("updateOrder", json.order)

						console.log('FP: order addProduct json: ', json);
						console.log('FP: order addProduct json.order: ', json.order);
					}

					return json;

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},

		updateCompany({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			commit("requestStart");

			const request = util.getPOSTRequest(this.state.loginToken, data.background, data.company);


			return fetch(settings.baseUrl + "user/company", request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {
						commit(COMMIT_UPDATE_COMPANY, json.company)
					}

					return json;

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},
		updateUser({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			commit("requestStart");


			const request = util.getPOSTRequest(this.state.loginToken, data.background, data.user);

			return fetch(settings.baseUrl + "user", request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {
						commit(COMMIT_UPDATE_USER, json.user)
						
					}

					return json;

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},
		updateUserPassword({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			commit("requestStart");

			const post = { oldPassword: data.oldPassword, newPassword: data.newPassword};


			const request = util.getPOSTRequest(this.state.loginToken, data.background, post);

			return fetch(settings.baseUrl + "user/up", request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					return json;

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},

	},
	mutations: {

		updateOrder(state, order) {

			console.log('FP: mutation updateOrder, order:', order);

			const currentOrder = state.data?.userModel?.orderList[order.orderId];



			if (currentOrder) {
				order.meta = currentOrder.meta
				order.meta.edited = false

				
				
			} else {
				order.meta = {}

				if (order.dropship) {
					order.meta.previousOrderId = state.data.currentOrderId
				}
			}


			order.meta.updating = false

			state.data.userModel.orderList[order.orderId] = order

			console.log('FP: mutation updateOrder, orderList:', state.data.userModel.orderList);
			console.log('FP: mutation updateOrder, order:', state.data.userModel.orderList[order.orderId]);




			if (state.data.currentOrderId == null || order.dropship) {
				state.data.currentOrderId = order.orderId
				order.meta.expanded = true
				order.meta.sort = 0;
			}



		},
		updateCustomer(state, customer) {

			console.log('FP: mutation updateCustomer, customer:', customer);
			
			const currentCustomer = state.data?.userModel?.customerList[customer.customerId];

			if (currentCustomer) {
				customer.meta = currentCustomer.meta
				customer.meta.edited = false
			} else {
				customer.meta = {}
			}

			customer.meta.updating = false

			state.data.userModel.customerList[customer.customerId] = customer

		},
		moveOrderFirst(state, orderId) {

			const order = state.data.userModel.orderList[orderId];
			if (order) {
				order.meta.sort = 0
				state.data.userModel.orderList[orderId] = order
			}


		},
		resetPreviousOrderId(state) {

			console.log('FP: mutation resetPreviousOrderId: ');

			for (let index = 0; index < state.data.userModel?.orderList?.length; index++) {
				
				const order = state.data.userModel?.orderList[index];
				
				if (order && order.meta && order.meta.previousOrderId){
					order.meta.previousOrderId = null;
				}

				
				state.data.userModel.orderList[index] = order;
				
			}

		},

		mergeOrder(state, order) {

			const currentOrder = state.data.userModel.orderList[order.orderId];

			if (!currentOrder) {
				util.appendEventLogError("Hittade ingen order att uppdatera");
				return;
			}

			order.meta = currentOrder.meta

			if (currentOrder.meta.edited) {
				order.contactPerson = currentOrder.contactPerson
				alert("Fyll på fler");
			}

			order.meta.updating = false
			state.data.userModel.orderList[order.orderId] = order

		},
		updateOrderRows(state, order){

			

			const currentOrder = state.data.userModel.orderList[order.orderId];

			if (currentOrder) {
				currentOrder.orderRowList = order.orderRowList
			}

			state.data.userModel.orderList[order.orderId] = currentOrder
		},

		updateCompany(state, company){
			state.data.userModel.company = company
		},

		updateUser(state, user) {
			state.data.userModel.user = user
		},



		updateUserModel(state, userModel) { // ersätter befintlig modell 


			console.log('FP: mutation updateUserModel: ', userModel);
			

			var sortedOrderList = [];


			sortedOrderList = userModel.orderList.sort((a, b) => {
				if (a.orderStatus && b.orderStatus && a.orderStatus.status != b.orderStatus.status) {

					return a.orderStatus.status - b.orderStatus.status
				}

				if (a.orderStatusDate && b.orderStatusDate) {
					return (a.orderStatusDate + '').localeCompare(b.orderStatusDate)
				}


				return b.orderId - a.orderId

			}

			);

			var sort = 0;

			var indexedOrderList = [];

			sortedOrderList.forEach(order => { // FP: Indexerar orderlistan 
				order.meta = {}
				order.meta.updating = false
				order.meta.sort = sort
				indexedOrderList[order.orderId] = order
				sort = sort + 1
			})

			userModel.orderList = indexedOrderList;

			// customerList
			var indexedCustomList = [];

			userModel.customerList?.forEach(customer => {
				customer.meta = {}
				customer.meta.updating = false
				customer.meta.edited = false
				indexedCustomList[customer.customerId] = customer;

			})

			userModel.customerList = indexedCustomList;

			state.data.userModel = userModel // byt ut mot modellen som vi hämtat. 

			if (state.data.currentOrderId == null && userModel.suggestedOrderId > 0) {

				state.data.currentOrderId = userModel.suggestedOrderId

				const order = userModel.orderList[state.data.currentOrderId];

				if (order) {
					order.meta.expanded = true
				}

				state.data.userModel.orderList[state.data.currentOrderId] = order; // FP: 2025-10-29 ändrade här från usermodel till state.data.usermodel. 
			}

		},

		updateOrderRowMessage(state,  data){
			
			const order = data.order;
			const orderRowId = data.orderRowId;

			state.data.orderRowMessage.message = data.orderRowMessage
			state.data.orderRowMessage.orderId = order.orderId
			state.data.orderRowMessage.orderRowId = orderRowId

			//const orderRow = order?.orderRowList?.find(orderRow => orderRow.orderRowId == orderRowId)

			clearTimeout(state.data.orderRowMessage.timer);

			state.data.orderRowMessage.timeout = false

			if (state.data.orderRowMessage.active != true){
				state.data.orderRowMessage.active = false
			}
			

			const timer = setTimeout(() => {
				
				
				state.data.orderRowMessage.timer = null
				state.data.orderRowMessage.timeout = true

				if (!state.data.orderRowMessage.active){
					setTimeout(() => {
						state.data.orderRowMessage.message = null
					}, 500);
				}
				

			}, 3000)

			state.data.orderRowMessage.timer = timer;
		},

		setDisplayPrice1(state, displayPrice1){
			state.data.displayPrice1 = displayPrice1
		},

		deleteUserModel(state) {
			state.data.userModel = null;
		},
		setCurrentOrderId(state, currentOrderId) {
			state.data.currentOrderId = currentOrderId

		},
		deleteOrder(state, orderId) {
			state.data.userModel.orderList[orderId] = null;
		},

		closeAllOrders(state) {
			state.data.userModel.orderList.map(order => order.meta.expanded = false)
		},
		expandAllOrders(state) {
			state.data.userModel.orderList.map(order => order.meta.expanded = true)
		},
		setFilter(state, filter) {
			state.data.filter = filter
		},

		setTempProduct(state, product){
			state.data.tempProduct = product
		},


		requestStart(state) {
			state.data.requestCount++
		},
		requestComplete(state) {

			state.data.requestCount--

			if (state.data.requestCount < 0) {
				state.data.requestCount = 0;
			}
		}

	}
}


